export default __webpack_public_path__ + "static/media/css.9d56f943.png";